import { Component, EventEmitter, inject, OnInit, Output } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import {
  Router,
  NavigationEnd,
  RouterLink,
  RouterLinkActive,
} from "@angular/router";
import { SvgIconComponent } from "angular-svg-icon";
import { DropDown } from "../drop-down/drop-down";
import { filter } from "rxjs/operators";
import { FirebaseAuthService } from "../../services/firebase-auth.service";
import { Settings } from "../../utils/settings";

@Component({
  selector: "app-nav-top-secure",
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    SvgIconComponent,
    DropDown,
    RouterLink,
    RouterLinkActive,
  ],
  templateUrl: "./nav-top-secure.html",
  styleUrls: ["./nav-top-secure.scss"],
})
export class NavTopSecure implements OnInit {
  private router = inject(Router);
  private firebaseAuth = inject(FirebaseAuthService);

  theme = "";
  isLoginRoute = false;
  isLoggedIn = false;
  showDrawer = false;
  isDocsRoute = false;
  @Output() toggleDrawer = new EventEmitter<unknown>();

  constructor() {}

  // toggleDrawer() {
  //   this.showDrawer = !this.showDrawer;
  // }

  async ngOnInit() {
    // Listen to route changes to update isLoginRoute and isDocsRoute
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.isLoginRoute = event.url === "/login";
        this.updateDocsRoute(event.url);
      });

    // Set initial state based on current URL
    this.isLoginRoute = this.router.url === "/login";
    this.updateDocsRoute(this.router.url);
    console.log("this.isLoginRoute: ", this.isLoginRoute);

    // Subscribe to auth state
    this.firebaseAuth.user$.subscribe((user) => {
      this.isLoggedIn = !!user;
    });

    // Load theme from Settings on init
    const savedTheme = await Settings.get<string>("theme");

    console.log("Saved theme from Settings:", savedTheme);

    // Use setTimeout to ensure the select element is fully initialized
    setTimeout(() => {
      if (savedTheme) {
        // Only set the theme if it's 'light' or 'dark' (valid options in the select)
        if (savedTheme === "light" || savedTheme === "dark") {
          this.theme = savedTheme;
        } else {
          // If it's another theme (like 'cupcake'), default to empty
          this.theme = "";
        }
        document.documentElement.setAttribute("data-theme", savedTheme);
      } else {
        // No saved theme, set empty string to show placeholder
        this.theme = "";
      }

      console.log("Theme set to:", this.theme);
    }, 0);
  }

  async changeTheme(event: Event): Promise<void> {
    const selectElement = event.target as HTMLSelectElement;
    const selectedTheme = selectElement.value;
    this.theme = document.documentElement.getAttribute("data-theme")!;
    if (this.theme === "light") {
      document.documentElement.setAttribute("data-theme", "dark");
      this.theme = "dark";
      await Settings.set("theme", "dark");
    } else {
      document.documentElement.setAttribute("data-theme", "light");
      this.theme = "light";
      await Settings.set("theme", "light");
    }
  }

  async onThemeSelectChange(event: Event): Promise<void> {
    const selectElement = event.target as HTMLSelectElement;
    const selectedTheme = selectElement.value;
    this.theme = selectedTheme;
    document.documentElement.setAttribute("data-theme", selectedTheme);
    await Settings.set("theme", selectedTheme);
  }

  updateDocsRoute(url: string): void {
    // Check if current URL is a docs route (either /docs/* or /dashboard/docs/*)
    this.isDocsRoute =
      url.startsWith("/docs") || url.startsWith("/dashboard/docs");
  }

  async onLogout(): Promise<void> {
    this.firebaseAuth.signOut().then(async () => {
      await Settings.remove("isAuthenticated");
      await Settings.remove("rememberedEmail");
      this.router.navigate(["/logout"]);
    });
  }
}
